<template>
  <div class="edudash-bottom-nav">
    <v-bottom-nav
      app
      :active.sync="bottomNav"
      :value="needBottomNav"
      :color="this.$vuetify.theme.secondaryLabels"
      height="64px"
    >
      <v-btn value="feedList" color="primary" flat>
        <span class="nav-text">Home</span>
        <v-icon>$vuetify.icons.icon_logo</v-icon>
      </v-btn>

      <v-btn value="RegularProjects" color="primary" flat>
        <span class="nav-text">Fazer uma avaliação</span>
        <v-badge color="red" :value="hasPendingEvaluations">
          <template v-slot:badge>
            <span>!</span>
          </template>
          <v-icon>local_library</v-icon>
        </v-badge>
      </v-btn>

      <v-btn value="IndisciplineAndHealth" color="primary" flat>
        <span class="nav-text">Alertas</span>
        <v-icon>$vuetify.icons.custom_alert</v-icon>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BottomNav',
  data() {
    return {
      bottomNav: this.bottomNavValue,
    };
  },
  computed: {
    ...mapGetters(['currentPrincipal', 'currentTab', 'getHasPendingEvaluations']),
    bottomNavValue() {
      return this.currentTab;
    },
    hasPendingEvaluations() {
      return this.getHasPendingEvaluations;
    },
    needBottomNav() {
      return this.$route.meta.needBottomNav || false;
    },
  },
  watch: {
    bottomNav(page) {
      this.$router.push({ name: page, params: { jwt_token: this.currentPrincipal.jwt_token } });
    },
    currentTab(value) {
      if (value) {
        this.bottomNav = value;
      }
    },
  },
  mounted() {
    this.bottomNav = this.$route.name;
  },
};
</script>
<style lang="scss">
.edudash-bottom-nav {
  .nav-text {
    @include font-monteserrat-semi-bold;
    font-size: 10px;
  }
}
</style>
